import React, { useState, useEffect } from "react";
import Classes from "./styles/style.module.css";
import { LuSettings2 } from "react-icons/lu";
import { IoCloseCircleSharp } from "react-icons/io5";

const BlogFilters = ({ handleClick, selected, archive, searchQuery }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  let filters = [
    { label: "روابط عمومی", value: "PRNews" },
    { label: "روشنا", value: "Roshana" },    
    { label: "هابل", value: "Hubble" },
    { label: "راه بهشت۱۴۰۳", value: "RaheBehesht1403" },
    { label: "راه بهشت۱۴۰۴", value: "RaheBehesht1404" },
    { label: "جفت پوچ", value: "general" },
    { label: "نتایج پویش ها", value: "Result" },
  ];

  const ValidFilters = [
    "خانوادهـباکلاسـخانوادهـباـکتاب",
    //More filters for blogs can be added here as needed
  ];

  if (archive) {
    filters = [
      { label: "روشنا", value: "روشنا" },
      { label: "رویدادها", value: "رویدادها" },
      { label: "اکران فیلم", value: "اکران فیلم" },
      { label: "جفت پوچ", value: "جفت پوچ" },
      { label: "سایر پویش ها", value: "سایر پویش ها" },
      { label: "ارغوان", value: "ارغوان" },
      { label: "ویترین جوایز", value: "ویترین جوایز" },
      { label: "ماجرا", value: "ماجرا" },

      { label: "نتایج", value: "نتایج" },
      { label: "راه بهشت", value: "راه بهشت" },

      // { label: "روابط عمومی", value: "روابط عمومی" },
      // { label: "لیگ قرآنی", value: "لیگ قرآنی" },
      // { label: "رویداد", value: "رویداد" }
    ];
  }

  useEffect(() => {
    if (searchQuery) {
      const isValid = ValidFilters.indexOf(searchQuery) !== -1;
      if (isValid) {
        const applyFilter = handleClick;
        applyFilter(searchQuery);
      }
    }
  }, [searchQuery]);

  const handleFilterClick = (value) => {
    handleClick(value);
    setIsExpanded(false);
  };

  const handleClear = () => {
    handleClick("");
    setIsExpanded(false);
  };

  return (
    <div className={Classes.filterContainer}>
      <div
        className={Classes.iconButton}
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <LuSettings2 className={Classes.ConfIcon} fontSize={20} />
      </div>
      <div className={Classes.filterWrapper}>
        <div
          onClick={() => setIsExpanded((prev) => !prev)}
          className={`${Classes.filterItem} ${
            selected || selected === "" ? Classes.selected : ""
          }`}
        >
          {selected !== "" && (
            <div className={Classes.iconButton} onClick={handleClear}>
              <IoCloseCircleSharp fontSize={20} />
            </div>
          )}
          {selected === ""
            ? "همه"
            : ValidFilters.indexOf(selected) !== -1
            ? selected
            : filters.find((f) => f.value === selected)?.label || "پرونده ها"}
        </div>
      </div>

      {isExpanded && (
        <div className={Classes.filterList}>
          {filters.map((filter) => (
            <div
              key={filter.value}
              className={`${Classes.filterItem} ${
                selected === filter.value ? Classes.selected : ""
              }`}
              onClick={() => handleFilterClick(filter.value)}
            >
              {filter.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BlogFilters;
